module.exports = __webpack_public_path__ + "img/no-activities.90ee10c2.png";